<template>
      <div class="row">
        <div class="col-12">
          <vue-meeting-selector
            class="simple-example__meeting-selector"
            :calendar-options="{
              daysLabel:[
                  'Dim.',
                  'Lun.',
                  'Mar.',
                  'Mer.',
                  'Jeu.',
                  'Ven.',
                  'Sam.',
                ],
              monthsLabel:[
                  'Jan.',
                  'Fév.',
                  'Mar.',
                  'Avr.',
                  'Mai.',
                  'Jun.',
                  'Juil.',
                  'Août.',
                  'Sep.',
                  'Oct.',
                  'Nov.',
                  'Déc.',
                ]
            }"
            v-model="meeting"
            :date="date"
            :loading="loading"
            :class-names="classNames"
            :meetings-days="meetingsDays"
            @next-date="nextDate"
            @previous-date="previousDate"
          >
            <!--<template
                    #header="{ meetings }">
                <div class="title">{{ meetings.date }}</div>
            </template>-->
          </vue-meeting-selector>
        </div>
      </div>
</template>

<script>

    import VueMeetingSelector from "vue-meeting-selector";

    export default {
        name: "Calendar",
      props: {
        initDate:String,
      },
      components: {
        VueMeetingSelector,
      },
      watch: {
        meeting: function (val) {

          this.$emit("do-selected-date",val)
        },

      },
      data() {
        return {
          date: null,
          meetingsDays: [],
          meeting: null,
          loading: true,
          nbDaysToDisplay: 8,
        };
      },
      computed: {
        classNames() {
          // because of line-height, font-type you might need to change top value
          return {
            tabLoading: 'loading-div',
          };
        },
      },
      methods: {
        nextStep(){
          this.$emit("do-selected-date",this.meeting)
        },
        // @click on button-right
        async nextDate() {
          console.log("nextDate");


          // display loading
          this.loading = true;
          // calcul new Date and change actual

          this.date.setDate(this.date.getDate() + 7);
          this.LoadCallendar(this.date).then((response)=>{
            console.log("response",response);
            this.meetingsDays = response.data;
            this.loading = false;
          }).catch((erreur)=>{
            console.log(erreur)
            this.loading = false;
          })
          // get meetings with async function
         // this.meetingsDays = await getNewDates(this.date);
          // hide loading

        },
        // @click on button-left
        async previousDate() {

          this.loading = true;

          this.date.setDate(this.date.getDate() - 7);
          this.LoadCallendar(this.date).then((response)=>{
            console.log("response",response)
            this.meetingsDays = response.data;
            this.loading = false;
          }).catch((erreur)=>{
            console.log(erreur)
            this.loading = false;
          })

        },
        searchByDate(date, nbparticipants) {
          this.date = date;
          this.meeting ={
            date : date
          } ;
          this.loading = true;
          this.LoadCallendar(this.date, nbparticipants).then((response)=>{
            console.log("response ",response)
            this.meetingsDays = response.data;
            this.loading = false;
          }).catch((erreur)=>{
            console.log(erreur)
            this.loading = false;
          })
        },
        formatDate(date) {
          var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

          if (month.length < 2)
            month = '0' + month;
          if (day.length < 2)
            day = '0' + day;

          return [year, month, day].join('-');
        },
        LoadCallendar(currentDate, nbparticipants = 1) {
          return window.PublicAxios.get('/commercant/'+window.info.refCom+'/prestation/'+window.info.refPrestation+'/calendar', {
            params: {
              date: this.formatDate(currentDate),
              nbparticipants: nbparticipants,
            }
          })
        }
      },
      async created() {

          if(this.initDate){
            this.meeting ={
              date : new Date(this.initDate)
            } ;
          }

        this.LoadCallendar(this.date).then((response)=>{
          console.log("response ",response)
          this.meetingsDays = response.data;
          this.loading = false;
        }).catch((erreur)=>{
          console.log(erreur)
          this.loading = false;
        })

      },

    }
</script>
